import { createType } from 'framework/utils/createType';

export const CustomerAccountDetailTabTypes = createType('sales', 'settlementProposals', 'payments');
export type CustomerAccountDetailTabType = typeof CustomerAccountDetailTabTypes[number];
